import { useCallback, useState } from 'react'
import styles from './CodeBlock.module.css'

export interface CodeBlockProps {
  children: string
  /** Shown in the corner, e.g. "bash" or ".npmrc". */
  label?: string
}

export function CodeBlock({ children, label }: CodeBlockProps) {
  const [copied, setCopied] = useState(false)

  const copy = useCallback(() => {
    // Clipboard access is refused on insecure origins and by permission; a
    // failed copy should do nothing rather than throw an unhandled rejection.
    navigator.clipboard?.writeText(children).then(
      () => {
        setCopied(true)
        window.setTimeout(() => setCopied(false), 1500)
      },
      () => setCopied(false)
    )
  }, [children])

  return (
    <div className={styles.block} data-testid="code-block">
      <div className={styles.head}>
        {label && <span className={styles.label}>{label}</span>}
        <button
          type="button"
          className={styles.copy}
          onClick={copy}
          data-testid="code-copy"
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <pre className={styles.pre}>
        <code>{children}</code>
      </pre>
    </div>
  )
}
